module.exports = "https://coursera_assets.s3.amazonaws.com/images/6b9e8cc8384a4df0e01906e76d64896d.png";